import React from 'react';
import {LocalOfferOutlined} from '@mui/icons-material';
import {tagServices} from '../../service/tagService';
import ReportMultiSelectFilter from '../utils/ReportMultiSelectFilter';

const loadOptions = async search => (await tagServices.read({name: search})).tags.map(item => item.name);
const getLabel = option => option;
const equal = (option, value) => option === value;

export default function TagFilter({inputValue = [], updateOnChange}) {
    return <ReportMultiSelectFilter value={inputValue} onChange={updateOnChange} loadOptions={loadOptions}
        label="Filter by tags" getLabel={getLabel} equal={equal}
        startIcon={<LocalOfferOutlined sx={{fontSize: 19, color: 'text.secondary'}}/>}/>;
}
